import { forwardRef, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useSearchField } from 'react-aria';
import PropTypes from 'prop-types';
import { useSearchFieldState } from 'react-stately';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

// eslint-disable-next-line react/display-name
const SearchField = forwardRef((props, ref) => {
    const { label, description, errorMessage, type, className } = props;
    const state = useSearchFieldState(props);
    const defaultRef = useRef();
    const TextFieldRef = ref || defaultRef;
    const { labelProps, inputProps, descriptionProps, errorMessageProps } = useSearchField(props, state, ref);
    const intl = useIntl();

    return (
        <div
            className={['govuk-form-group', errorMessage && 'govuk-form-group--error', className].join(' ')}
        >
            { label &&
                    <div className="govuk-label-wrapper">
                        <label {...labelProps} className="govuk-label govuk-label--l">
                            {label}
                        </label>
                    </div>
            }
            { description &&
                    <div {...descriptionProps} className="govuk-hint">
                        {description}
                    </div>
            }
            { errorMessage &&
                    <p {...errorMessageProps} className="govuk-error-message">
                        <span className="govuk-visually-hidden">{intl.formatMessage({ id: 'errorLabel' })}:</span> {errorMessage}
                    </p>
            }
            <input
                {...inputProps}
                ref={TextFieldRef}
                className={['govuk-input', errorMessage && 'govuk-input--error'].join(' ')}
                type={type}
            />
        </div>
    );
});

SearchField.propTypes = {
    ...defaultAriaProps,
    className: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    errorMessage: PropTypes.string,
    type: PropTypes.oneOf(['text', 'number'])
};

SearchField.defaultProps = {
    type: 'text'
};

export default SearchField;
